import { useState } from 'react';
import { isSupabaseError } from '../../../../constants/supabaseErrors';
import type { TopicDatabase } from '../../../../types';
import { useArchiveTopic } from '../../api/useArchiveTopic';
import { useUnarchiveTopic } from '../../api/useUnarchiveTopic';

type Props = {
  topic: TopicDatabase;
  onClose: () => void;
};

export function useTopicArchiveModal(props: Props) {
  const archiveTopic = useArchiveTopic();
  const unarchiveTopic = useUnarchiveTopic();
  const [serverError, setServerError] = useState<string | null>(null);
  const isArchived = Boolean(props.topic.archived);
  const isPending = archiveTopic.isPending || unarchiveTopic.isPending;

  async function handleConfirm() {
    setServerError(null);

    try {
      if (isArchived) {
        await unarchiveTopic.mutateAsync(props.topic.id);
      } else {
        await archiveTopic.mutateAsync(props.topic.id);
      }
      props.onClose();
    } catch (error: unknown) {
      setServerError(isSupabaseError(error) ? error.message : 'Une erreur est survenue. Réessayez.');
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    isArchived,
    isPending,
    serverError,
    handleConfirm,
    handleClose,
  };
}
